import {
  EventParticipation,
  ParticipationStatus,
  ParticipationStore,
} from '@lib/types/event-participation';

export interface ParticipationStoreDTO {
  id: string;
  name: string;
  slug: string;
  logoUrl: string | null;
  city: string | null;
  state: string | null;
}

export interface EventParticipationDTO {
  id: string;
  eventId: string;
  store: ParticipationStoreDTO;
  status: ParticipationStatus;
  onSiteSales: boolean;
  preOrders: boolean;
  preOrderDeadline: string | null;
  revision?: number;
  reason?: string | null;
  updatedAt?: string;
  history?: {
    id: string;
    action: string;
    actorName: string;
    reason: string | null;
    occurredAt: string;
    before: unknown;
    after: unknown;
  }[];
}

export interface ParticipationPageDTO {
  items: EventParticipationDTO[];
  total: number;
  page: number;
  limit: number;
  summary?: { confirmed: number; pending: number };
}

export interface ParticipationStoresDTO {
  items: ParticipationStoreDTO[];
  total: number;
  page: number;
  limit: number;
}

export const toStore = (store: ParticipationStoreDTO): ParticipationStore => ({
  id: store.id,
  name: store.name,
  slug: store.slug,
  logoUrl: store.logoUrl,
  city: store.city,
  state: store.state,
});

export const toParticipation = (
  item: EventParticipationDTO,
): EventParticipation => ({
  id: item.id,
  eventId: item.eventId,
  store: toStore(item.store),
  status: item.status,
  onSiteSales: item.onSiteSales,
  preOrders: item.preOrders,
  preOrderDeadline: item.preOrderDeadline,
  revision: item.revision,
  reason: item.reason,
  updatedAt: item.updatedAt,
  history: item.history?.map((entry) => ({
    id: entry.id,
    action: entry.action,
    actorName: entry.actorName,
    reason: entry.reason,
    occurredAt: entry.occurredAt,
    before: entry.before,
    after: entry.after,
  })),
});
